export default __webpack_public_path__ + "static/media/circle-play-regular.6618892a.svg";